import { API_URL } from '../constants/index'
import { postRequest } from './api'

export async function deleteWorkOrdersFromInvoice(values) {
  console.log('deleteWorkOrdersFromInvoice', values)
  return postRequest(`${API_URL}invoice2WorkOrder/deleteWorkOrdersFromInvoice`, values)
}

export default deleteWorkOrdersFromInvoice
